import { useEffect, useRef, useState } from "react";
import BreadCrumbComp from "../../../components/breadCrumb";
import LoadingFeedback, { useLoadingState } from "../../../components/loadingFeedback";
import LaddaButton from "../../../components/buttons/laddaButton";
import { icons } from "../../../constants";
import { useForm } from "react-hook-form";
import "../styles.css";
import { Grid } from "@mui/material";
import FormSelect from "../../../components/selects/formSelect";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import FormRadioButton from "../../../components/formRadioButton";
import {
  addOrUpdateServiceOrder,
  callApiAsync,
  callActionApiAsync,
  getBiomedicalDataByIspectionRecordId,
  getBiomedicalEquipmentBySeriesList,
  getDataByServiceOrderId,
  getEngineeringActExistence,
  getExistEngeneeringAct,
  getNonBusinessDay,
  getOrderStateByOrderActivity,
  getRequestValidation,
  getSelectsServiceOrder,
  getServiceOrderById,
  updateServiceOrderState
} from "../../../services/apiService";
import FormCalendar from "../../../components/calendar/formCalendar";
import FormAutocomplete from "../../../components/selects/formAutocomplete";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setEngineeringReportId,
  setServiceOrderId
} from "../../../redux/slices/serviceOrderSlice";
import { hasAnyRoleUtil } from "../../../services/roleService";
import CharacterCounter from "../../../components/characterCounter";
import FormTextField from "../../../components/textField/formTextField";
import { generateSelectList } from "../../../utils/utilsFunctions";
import { filterStatesByOrderState } from "./utils";
import ToastNotification from "../../../components/toastNotification";
import {
  activityServiceOrderEnum,
  statesServiceOrderEnum
} from "../../../constants/enums";
import { getCurrentDate } from "../../../services/dateService";
import ShowTable from "../../../components/tables/showTable";
import MultiSelect from "../../../components/selects/multiSelect";
import HistoryModalUnique from "../modals/historyModalUnique";
import { orderSelectActivity } from "../../../utils/orderActivity";
import FileUploadButton from "../../../components/fileUploadBtn";
import CreateVerificationModal from "./createVerificationModal";
import { BIOMEDICAL_SERVICE_ORDER_EDIT_ROLES } from "../../../constants/biomedicalRoles";

const CreateRequest = () => {
  const [loadingDetails, setLoadingDetails] = useLoadingState(true);
  const [loadingEquipment, setLoadingEquipment] = useLoadingState();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userData = useSelector((state) => state.userData.userData);
  const serviceOrderId = useSelector(
    (state) => state.serviceOrder.serviceOrderId
  );

  const [inspectionRecordList, setInspectionRecordList] = useState([]);
  const [institutionList, setInstitutionList] = useState([]);
  const [serieList, setSerieList] = useState([]);
  const [engineerInChargeData, setEngineerInChargeData] = useState([]);
  const [activityData, setActivityData] = useState([]);
  const [serviceOrderList, setServiceOrderList] = useState([]);
  const [ServiceOrderName, setServiceOrderName] = useState(null);
  const [currenState, setCurrenState] = useState(null);
  const [isEndSO, setIsEndSO] = useState(false);
  const [commentShow, setCommentShow] = useState(true);
  const [disabledDates, setDisabledDates] = useState([]);
  const [lastState, setLastState] = useState(null);
  const [seriesDataTable, setSeriesDataTable] = useState([]);
  const [isMultiSerie, setIsMultiSerie] = useState(true);
  const [openHistory, setOpenHistory] = useState(false);
  const [refreshStateFilter, setRefreshStateFilter] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [openRequestValidation, setOpenRequestValidation] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: "success",
    summary: "",
    detail: ""
  });

  // NEW: control para confirmación de duplicado
  const [pendingPayload, setPendingPayload] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const savePhaseRef = useRef("idle");
  const previousSerieIdsRef = useRef([]);

  const urlApi = process.env.REACT_APP_API_URL;

  const [stateList, setStateList] = useState([]);
  const [stateListFiltered, setStateListFiltered] = useState([]);
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const handleFileChange = (file) => {
    setFile(file);
  };

  const requiresComment = (state) => {
    const s = Number(state);
    return ![
      statesServiceOrderEnum.ServiceOrderCreation,
      statesServiceOrderEnum.DeliveryOSClosure,
      statesServiceOrderEnum.Completed,
      statesServiceOrderEnum.EngineerinReport,
      statesServiceOrderEnum.Testing,
      statesServiceOrderEnum.Return
    ].includes(s);
  };

  const today = new Date();
  const minDate = today;
  const maxDate = new Date(today.getFullYear(), 11, 31);

  const isServiceOrderManagment = hasAnyRoleUtil(
    BIOMEDICAL_SERVICE_ORDER_EDIT_ROLES,
    userData.roleList
  );
  const isReadOnlyServiceOrder = !isServiceOrderManagment;

  const isReadOnly = isReadOnlyServiceOrder && !isServiceOrderManagment;

  const validationSchema = yup.object().shape({
    engineerInCharge: yup
      .string()
      .required("El ingeniero a cargo es obligatorio"),
    activity: yup.string().required("La actividad es obligatoria"),
    institution: yup.object().required("La institución es obligatoria"),
    creationOrderDate: yup
      .date()
      .transform((value, originalValue) => {
        return originalValue ? new Date(originalValue) : null;
      })
      .typeError("La fecha no es válida")
      .required("La fecha de creación es obligatoria"),
    serie: yup
      .array()
      .of(yup.string().required("Cada ID de serie es obligatorio"))
      .min(1, "Debe seleccionar al menos una serie")
      .required("La serie es obligatoria"),
    visitResult: yup
      .string()
      .required("El resultado de la visita es obligatorio"),
    state: yup.string().required("El estado es obligatorio"),
    comment: yup
      .string()
      .nullable()
      .when("state", (stateVal, schema) =>
        requiresComment(stateVal)
          ? schema.required("El comentario es obligatorio")
          : schema.notRequired()
      )
  });

  const {
    control: controlForm,
    getValues: getValuesForm,
    formState: { errors },
    handleSubmit,
    setValue,
    watch
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
    reValidateMode: "onChange"
  });

  const selectedState = watch("state");

  useEffect(() => {
    if (selectedState === String(statesServiceOrderEnum.DeliveryOSClosure)) {
      setValue("comment", "Cierre de OS", { shouldValidate: true });
    }
  }, [selectedState, setValue]);

  const ispectionRecordId = watch("otherIT");
  const activityWatch = watch("activity");
  const serviceOrderInputId = watch("serviceOrder");
  const stateWatch = watch("state");
  const visitResultWatch = watch("visitResult");
  const institutionWatch = watch("institution");
  const watchSerieId = watch("serie");
  const isEdit = serviceOrderId && serviceOrderId !== 0;
  const isCompleted = stateWatch === statesServiceOrderEnum.Completed;
  const isEngineerReport =
    stateWatch === statesServiceOrderEnum.EngineerinReport;
  const showTestingBtn = Number(stateWatch) === statesServiceOrderEnum.Testing;

  const loadData = (data) => {
    const currentSerieIds = normalizeSerieIds(getValuesForm("serie"));
    const normalizedSerieIds = normalizeSerieIds(data.seriesIdList);
    const serieIdsToApply =
      normalizedSerieIds.length > 0 ? normalizedSerieIds : currentSerieIds;

    setCurrenState(data.state);
    setServiceOrderName(data.serviceOrderName || "");
    setValue("serie", serieIdsToApply);

    setValue("engineerInCharge", data.engineerInCharge || "");
    setValue("activity", data.order_activity_id || "");
    setValue(
      "institution",
      data.institutionId
        ? { value: data.institutionId, name: data.institutionName }
        : null
    );
    setValue(
      "creationOrderDate",
      data.creationOrderDate ? new Date(data.creationOrderDate) : null
    );
    setValue("visitResult", data.visitResult ? 1 : 0);
    setValue("state", data.state || "");
    setLastState(data.state);
    setValue(
      "otherIT",
      data.otherIT ? { value: data.otherIT, name: data.otherITName } : null
    );
    setValue(
      "serviceOrder",
      data.otherServiceOrderId
        ? { value: data.otherServiceOrderId, name: data.otherServiceOrderIdname }
        : null
    );

    setIsEndSO(
      data.state === statesServiceOrderEnum.DeliveryOSClosure ||
        data.state === statesServiceOrderEnum.Completed
    );

    setCommentShow(data.state != statesServiceOrderEnum.Completed);

    const path = data.serviceOrderHistoryImages?.[0]?.image_path;
    if (path) {
      const fileUrlExample = `${urlApi}/${path}`;
      setFileUrl(fileUrlExample);
    }
  };

  const clearEquipmentFields = () => {
    setValue("equipment", null);
    setValue("brand", "");
    setValue("model", "");
    setValue("serie", null);
  };

  const normalizeSerieIds = (serieValues) => {
    const values = Array.isArray(serieValues)
      ? serieValues
      : serieValues != null && serieValues !== ""
      ? [serieValues]
      : [];

    return values
      .map((serieValue) => {
        const rawValue =
          typeof serieValue === "object" && serieValue !== null
            ? serieValue.value ??
              serieValue.id ??
              serieValue.biomedical_equipment_id ??
              serieValue.serie_id
            : serieValue;

        const matchedOption = serieList.find(
          (option) => String(option.value) === String(rawValue)
        );

        return matchedOption ? matchedOption.value : rawValue;
      })
      .filter((value) => value != null && value !== "");
  };

  const getSerieOptionById = (serieId) =>
    serieList.find((option) => String(option.value) === String(serieId)) ||
    null;

  const normalizedWatchSerieIds = normalizeSerieIds(watchSerieId);

  const getExistenceEngReport = async (id) => {
    let exists = true;
    await callApiAsync(
      () => getEngineeringActExistence(id),
      (data) => {
        if (data.exists === false) {
          setToastConfig({
            severity: "error",
            summary: "Reporte de Ingeniería requerido",
            detail: "Debe llenar el reporte de ingeniería para continuar."
          });
          setShowToast(true);
          exists = false;
          return;
        }
      }
    );
    return exists;
  };

const getRequiretmentValidation = async (payload) => {
  try {
    const resp = await getRequestValidation(payload);
    const value = resp?.data ?? resp;
    return typeof value === 'boolean' ? value : !!value?.exists;
  } catch {
    return false;
  }
};

  const submitCore = async (data) => {
    let savedServiceOrderId;
    try {

      if (!isEndSO && isEdit && String(data.state) === String(currenState)) {
        setToastConfig({
          severity: "error",
          summary: "Error al cambiar estado",
          detail: "Debe seleccionar un estado diferente al actual."
        });
        setShowToast(true);
        return;
      }

      const requiresFile =
        String(data.state) === String(statesServiceOrderEnum.Testing) ||
        String(data.state) === String(statesServiceOrderEnum.Return);
      const hasFile = !!file;
      if (requiresFile && !hasFile) {
        setToastConfig({
          severity: "error",
          summary: "Archivo requerido",
          detail: "Debe adjuntar un archivo antes de continuar."
        });
        setShowToast(true);
        return;
      }

      const multiSerieActivities = [
        activityServiceOrderEnum.Setup,
        activityServiceOrderEnum.ConsumablesAdjustment,
        activityServiceOrderEnum.AcademicActivity,
        activityServiceOrderEnum.PreInstallation,
        activityServiceOrderEnum.Installation,
        activityServiceOrderEnum.SoftwareUpdate,
        activityServiceOrderEnum.Training,
        activityServiceOrderEnum.PredictiveVisit,
        activityServiceOrderEnum.ConsumablesAdjustment,
        activityServiceOrderEnum.TechnicalAssist
      ];
      const isMultiSerieLocal = multiSerieActivities.includes(activityWatch);
      setIsMultiSerie(isMultiSerieLocal);

      if (isMultiSerieLocal && seriesDataTable.length === 0) {
        setToastConfig({
          severity: "warn",
          summary: "Debes seleccionar una serie",
          detail: "Esta actividad requiere al menos un equipo biomédico"
        });
        setShowToast(true);
        return;
      }
      if (!isMultiSerieLocal && seriesDataTable.length > 1) {
        setToastConfig({
          severity: "warn",
          summary: "No puedes seleccionar más de 1 serie",
          detail: "Esta actividad no permite múltiples equipos biomédicos"
        });
        setShowToast(true);
        return;
      }

      if (isEdit && isServiceOrderManagment) {
        const isDeliveryClosure =
          Number(data.state) === statesServiceOrderEnum.DeliveryOSClosure;
        const fdUpd = new FormData();
        fdUpd.append("requestId", crypto.randomUUID());
        fdUpd.append("serviceOrderId", String(serviceOrderId ?? 0));
        fdUpd.append("userId", String(userData.id));
        fdUpd.append(
          "state",
          String(
            isDeliveryClosure ? statesServiceOrderEnum.Completed : data.state
          )
        );
        fdUpd.append(
          "comment",
          isDeliveryClosure
            ? data.comment?.trim() || "Cierre de OS"
            : data.comment ?? ""
        );
        fdUpd.append("currentDate", getCurrentDate());

        if (file) {
          fdUpd.append("file", file, file.name);
        }

        await callApiAsync(
          () => updateServiceOrderState(fdUpd),
          async () => {
            if (isDeliveryClosure) {
              setValue("state", statesServiceOrderEnum.Completed, {
                shouldValidate: false
              });
            }
            await getServiceOrderData();
            setValue("comment", "");
          }
        );
        setRefreshStateFilter((prev) => !prev);
        return;
      }

      // Creación / actualización
      const fd = new FormData();
      fd.append("requestId", crypto.randomUUID());
      fd.append("id", serviceOrderId ? String(serviceOrderId) : "0");
      fd.append("userId", String(userData.id));
      fd.append("currentDate", getCurrentDate());
      fd.append("state", String(data.state ?? ""));
      fd.append("visitResult", String(data.visitResult ?? ""));
      fd.append(
        "creationOrderDate",
        data.creationOrderDate
          ? new Date(data.creationOrderDate).toISOString()
          : ""
      );
      fd.append("engineerInCharge", String(data.engineerInCharge ?? ""));
      fd.append("activity", String(data.activity ?? ""));

      let finalComment = data.comment ?? null;
      if (
        String(data.state) ===
          String(statesServiceOrderEnum.DeliveryOSClosure) ||
        String(data.state) ===
          String(statesServiceOrderEnum.ServiceOrderCreation)
      ) {
        finalComment = data.comment?.trim() || null;
      }
      if (String(data.state) === String(statesServiceOrderEnum.Testing)) {
        finalComment = null;
      }
      fd.append("comment", finalComment ?? "");
      fd.append("institution", JSON.stringify(data.institution ?? null));
      fd.append("otherIT", JSON.stringify(data.otherIT ?? null));
      fd.append("serviceOrder", JSON.stringify(data.serviceOrder ?? null));
      fd.append("serie", JSON.stringify(data.serie ?? []));
      fd.append("seriesDataTable", JSON.stringify(seriesDataTable ?? []));

      if (file) {
        fd.append("file", file, file.name);
      }

      await callActionApiAsync(
        () => addOrUpdateServiceOrder(fd),
        (resp) => {
          const nextServiceOrderId = resp?.serviceOrderId;

          setValue("comment", "");
          dispatch(setServiceOrderId(nextServiceOrderId));
          dispatch(setEngineeringReportId(nextServiceOrderId));
          setServiceOrderName(resp.serviceOrderName);
          savedServiceOrderId = nextServiceOrderId;
          setRefreshStateFilter((prev) => !prev);
        },
        (error) => {
          setToastConfig({
            severity: "warn",
            summary: "Orden de servicio",
            detail: typeof error === "string" ? error : "No se pudo guardar la orden. Intente nuevamente."
          });
          setShowToast(true);
        }
      );
    } finally {
      if (savedServiceOrderId) await getServiceOrderData(savedServiceOrderId);
    }
  };

  const releaseSave = () => {
    savePhaseRef.current = "idle";
    setSubmitting(false);
  };

  const handleSaveSubmit = async (event) => {
    event.preventDefault();
    if (savePhaseRef.current !== "idle") return;
    // Lock before react-hook-form starts its asynchronous validation.
    savePhaseRef.current = "running";
    setSubmitting(true);
    try {
      await handleSubmit(onSubmit)(event);
    } finally {
      if (savePhaseRef.current !== "confirming") releaseSave();
    }
  };

  const onSubmit = async (data) => {
    if (
      String(data.state) === String(statesServiceOrderEnum.EngineerinReport)
    ) {
      const exists = await getExistenceEngReport(serviceOrderId);
      if (!exists) return;
    }
    if (
      String(data.state) === String(statesServiceOrderEnum.ServiceOrderCreation)
    ) {
      const existValidation = await getRequiretmentValidation(data);

      if (existValidation) {
        savePhaseRef.current = "confirming";
        setPendingPayload(data);
        setOpenRequestValidation(true); 
        return;
      }
    }
    await submitCore(data);
  };

  const handleConfirmYes = async () => {
    if (savePhaseRef.current !== "confirming") return;
    savePhaseRef.current = "running";
    setOpenRequestValidation(false);
    const data = pendingPayload;
    setPendingPayload(null);
    try {
      if (data) await submitCore(data);
    } finally {
      releaseSave();
    }
  };

  const handleConfirmNo = () => {
    if (savePhaseRef.current !== "confirming") return;
    releaseSave();
    setOpenRequestValidation(false);
    setPendingPayload(null);
  };

  const handleOpenHistory = () => {
    if (savePhaseRef.current !== "idle") return;
    setOpenHistory(true);
  };
  const handleCloseHistory = () => setOpenHistory(false);

  const selectsServiceOrder = async () => {
    await callApiAsync(
      () => getSelectsServiceOrder(),
      (data) => {
        setInspectionRecordList(data.inspectionRecordList);
        setServiceOrderList(data.serviceOrderList);
        setInstitutionList(data.institutionList);
        // Deduplicar por id de serie para conservar la institucion correcta.
        const serieIdList = data.serieIdList || [];
        const uniqueSerieList = Array.from(
          new Map(serieIdList.map((s) => [s.value, s])).values()
        );
        setSerieList(uniqueSerieList);
        setEngineerInChargeData(data.enginnerList);
        setActivityData(orderSelectActivity(data.activityList));
      },
      setLoadingDetails
    );
  };

  const setDataBiomedicalDataByIspectionRecordId = async () => {
    await callApiAsync(
      () => getBiomedicalDataByIspectionRecordId(ispectionRecordId.value),
      (data) => {
        setValue("equipment", { name: data.name, id: data.name } || "");
        setValue("brand", data.brand_id || "");
        setValue("model", data.model || "");
        setValue("serie", normalizeSerieIds([data.biomedical_equipment_id]));
      }
    );
  };

  const setDataByServiceOrderId = async (serviceOrderId) => {
    await callApiAsync(
      () => getDataByServiceOrderId(serviceOrderId),
      (data) => {
        setValue("equipment", { name: data.name, id: data.name } || "");
        setValue("brand", data.brand_id || "");
        setValue("model", data.model || "");
        setValue("serie", normalizeSerieIds([data.biomedical_equipment_id]));
      }
    );
  };

  const getServiceOrderData = async (targetServiceOrderId = serviceOrderId) => {
    const normalizedServiceOrderId = Number(targetServiceOrderId);
    if (!Number.isFinite(normalizedServiceOrderId) || normalizedServiceOrderId <= 0) {
      return;
    }

    await callApiAsync(
      () => getServiceOrderById(normalizedServiceOrderId),
      (data) => {
        loadData(data);
      },
      setLoadingDetails
    );
  };

  const getExistEngeneeringActData = async () => {
    await callApiAsync(
      () => getExistEngeneeringAct(serviceOrderId),
      (data) => {
        dispatch(setEngineeringReportId(data.Id));
        dispatch(setServiceOrderId(serviceOrderId));
      },
      () => {
        dispatch(setServiceOrderId(serviceOrderId));
      }
    );
  };

  const getNonBusinessDaysData = async () => {
    await callApiAsync(
      () => getNonBusinessDay(),
      (data) => {
        setDisabledDates(data);
      }
    );
  };

  const getStateByActivity = async () => {
    await callApiAsync(
      () => getOrderStateByOrderActivity(activityWatch),
      (data) => {
        setStateList(data);
      }
    );
  };

  const getBiomedicalEquipmentBySeriesTableData = async (serieListId) => {
    const dataToSend = { serieIds: serieListId };
    await callApiAsync(
      () => getBiomedicalEquipmentBySeriesList(dataToSend),
      (data) => {
        setSeriesDataTable(data);
      },
      setLoadingEquipment
    );
  };

  const columns = [
    { field: "serie_name", header: "Serie", align: "center", sortable: true },
    { field: "equipment", header: "Equipo", align: "center", sortable: true },
    { field: "model", header: "Modelo", align: "center", frozen: true },
    { field: "brand_name", header: "Marca", align: "center", frozen: true }
  ];

  useEffect(() => {
    if (!watchSerieId || watchSerieId.length === 0) {
      setSeriesDataTable([]);
      previousSerieIdsRef.current = [];
      if (!isEdit && institutionWatch) {
        setValue("institution", null, {
          shouldValidate: true,
          shouldDirty: true
        });
      }
      return;
    }
    const debounceTimer = setTimeout(() => {
      getBiomedicalEquipmentBySeriesTableData(normalizeSerieIds(watchSerieId));
    }, 300);
    return () => clearTimeout(debounceTimer);
  }, [institutionWatch, isEdit, setValue, watchSerieId]);

  useEffect(() => {
    if (isEdit) return;
    const selectedSerieIds = normalizeSerieIds(watchSerieId);
    if (selectedSerieIds.length === 0) {
      return;
    }

    const selectedSeries = selectedSerieIds
      .map((serieId) => getSerieOptionById(serieId))
      .filter(Boolean);

    if (selectedSeries.length !== selectedSerieIds.length) {
      previousSerieIdsRef.current = selectedSerieIds;
      return;
    }

    const unconfiguredSeries = selectedSeries.filter(
      (serie) => !Number(serie.institutionId) || !serie.institutionName
    );
    if (unconfiguredSeries.length) {
      const invalidIds = new Set(unconfiguredSeries.map((serie) => String(serie.value)));
      const correctedIds = selectedSerieIds.filter((id) => !invalidIds.has(String(id)));
      previousSerieIdsRef.current = correctedIds;
      setValue("serie", correctedIds, { shouldValidate: true, shouldDirty: true });
      setToastConfig({
        severity: "warn",
        summary: "Serie sin institución",
        detail: "La serie seleccionada no tiene una institución configurada en su hoja de vida. Este dato es obligatorio para crear la orden de servicio."
      });
      setShowToast(true);
      return;
    }

    const lockedInstitutionId =
      institutionWatch?.value ?? selectedSeries[0]?.institutionId ?? null;

    const invalidSeries = selectedSeries.filter(
      (serie) =>
        lockedInstitutionId != null &&
        serie.institutionId != null &&
        Number(serie.institutionId) !== Number(lockedInstitutionId)
    );

    if (invalidSeries.length > 0) {
      const previousSerieIds = Array.isArray(previousSerieIdsRef.current)
        ? previousSerieIdsRef.current
        : [];
      const addedSerieIds = selectedSerieIds.filter(
        (serieId) => !previousSerieIds.includes(serieId)
      );

      const correctedSerieIds = selectedSerieIds.filter((serieId) => {
        const serieOption = getSerieOptionById(serieId);
        if (!serieOption || serieOption.institutionId == null) return false;

        if (Number(serieOption.institutionId) !== Number(lockedInstitutionId)) {
          return !addedSerieIds.includes(serieId);
        }

        return true;
      });

      previousSerieIdsRef.current = correctedSerieIds;
      setValue("serie", correctedSerieIds, {
        shouldValidate: true,
        shouldDirty: true
      });
      setToastConfig({
        severity: "warn",
        summary: "Serie no permitida",
        detail: `Solo puede agregar series de la institucion ${
          institutionWatch?.name || selectedSeries[0]?.institutionName || ""
        }.`
      });
      setShowToast(true);
      return;
    }

    const firstSeriesInstitution = selectedSeries.find(
      (serie) => serie.institutionId != null
    );

    if (
      firstSeriesInstitution &&
      Number(institutionWatch?.value) !==
        Number(firstSeriesInstitution.institutionId)
    ) {
      setValue(
        "institution",
        {
          value: firstSeriesInstitution.institutionId,
          name: firstSeriesInstitution.institutionName
        },
        {
          shouldValidate: true,
          shouldDirty: true
        }
      );
    }

    previousSerieIdsRef.current = selectedSerieIds;
  }, [institutionWatch, isEdit, serieList, setValue, watchSerieId]);

  useEffect(() => {
    getServiceOrderData(serviceOrderId);
  }, [serviceOrderId]);

  useEffect(() => {
    if (!Array.isArray(watchSerieId) || watchSerieId.length === 0) return;
    if (!Array.isArray(serieList) || serieList.length === 0) return;

    const normalizedSerieIds = normalizeSerieIds(watchSerieId);
    const hasChanged =
      normalizedSerieIds.length !== watchSerieId.length ||
      normalizedSerieIds.some(
        (value, index) => String(value) !== String(watchSerieId[index])
      );

    if (hasChanged) {
      setValue("serie", normalizedSerieIds, {
        shouldValidate: false,
        shouldDirty: false
      });
    }
  }, [serieList, setValue, watchSerieId]);

  useEffect(() => {
    if (activityWatch) getStateByActivity();
  }, [activityWatch]);

  useEffect(() => {
    filterStatesByOrderState(
      stateList,
      !isEdit,
      stateWatch,
      activityWatch,
      setStateListFiltered
    );
  }, [stateList, activityWatch, refreshStateFilter]);

  useEffect(() => {
    getNonBusinessDaysData();
    selectsServiceOrder();
  }, []);

  useEffect(() => {
    if (stateWatch !== statesServiceOrderEnum.EngineerinReport) return;
    getExistEngeneeringActData();
  }, [stateWatch]);

  const handleEngineeringReport = async () => {
    if (savePhaseRef.current !== "idle") return;
    const target = statesServiceOrderEnum.EngineerinReport;

    if (serviceOrderId && currenState !== target) {
      const payload = {
        requestId: crypto.randomUUID(),
        serviceOrderId: serviceOrderId ?? 0,
        userId: userData.id,
        state: target,
        comment: getValuesForm("comment") || "",
        currentDate: getCurrentDate()
      };

      await callApiAsync(
        () => updateServiceOrderState(payload),
        () => {
          setCurrenState(target);
          setLastState(target);
          setValue("state", target, { shouldValidate: false });
          setRefreshStateFilter((prev) => !prev);
        }
      );
    }

    navigate(
      "/biomedicalManagementDashboard/serviceRecords/createEngineeringReport",
      { state: { isNew: true } }
    );
  };

  return (
    <div>
      <div inert={submitting ? "" : undefined}>
        <BreadCrumbComp />
      </div>
      <div className="searchTitle">
        <h1> </h1>
      </div>
      <div className="table-container">
        <div className="VContainer j-space-between">
          <h1 className="title-bio-details-chard">
            {ServiceOrderName == null
              ? "Nueva Orden de Servicio "
              : "Orden de Servicio - " + ServiceOrderName}
          </h1>
          <br className="br-white-space" />
          <div>
            <LoadingFeedback loading={loadingDetails} rows={8}>
            <form className="biomedical-service-order-form" onSubmit={handleSaveSubmit}>
              <fieldset disabled={submitting} style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}>
              {serviceOrderId && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "1rem"
                  }}
                >
                  <LaddaButton
                    type="button"
                    variant="contained"
                    height={"32px"}
                    onClick={handleOpenHistory}
                  >
                    <div className="IHContainer align-center">
                      <img
                        className="btn-icon"
                        src={icons.historialWhite}
                        alt="icon"
                        style={{ marginRight: "10px" }}
                      />
                      <p className="button_text">Historial</p>
                    </div>
                  </LaddaButton>
                </div>
              )}

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <FormSelect
                    name="engineerInCharge"
                    control={controlForm}
                    formLabel="Seleccionar un ingeniero a cargo"
                    label="Ingeniero a Cargo"
                    options={isEdit
                      ? engineerInChargeData
                      : engineerInChargeData.filter((engineer) => Number(engineer.is_active) === 1)}
                    error={errors.engineerInCharge}
                    disabled={isEdit || isReadOnly}
                    margin={"0"}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormSelect
                    name="activity"
                    control={controlForm}
                    formLabel="Actividad"
                    label="Actividad"
                    options={activityData}
                    error={errors.activity}
                    disabled={isEdit || isReadOnly}
                    margin={"0"}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormAutocomplete
                    name="institution"
                    control={controlForm}
                    label="Institución"
                    options={institutionList}
                    formLabel=""
                    error={errors.institution}
                    defaultValue={null}
                    disabled={true}
                    margin={"0"}
                  />
                </Grid>

                {/* Segunda fila */}
                <Grid item xs={12} sm={6} md={4}>
                  <FormRadioButton
                    name="visitResult"
                    control={controlForm}
                    label="Resultado de una Actividad Previa "
                    options={[
                      { label: "Sí", value: 1 },
                      { label: "No", value: 0 }
                    ]}
                    onChange={(value) => console.log("Seleccionado:", value)}
                    error={errors.visitResult}
                    disabled={isEdit || isReadOnly}
                  />
                </Grid>

                {visitResultWatch === 1 && (
                  <>
                    <Grid item xs={12} sm={6} md={4}>
                      <FormAutocomplete
                        name="otherIT"
                        control={controlForm}
                        label="Relacionar con otra acta de Inspección Técnica"
                        options={inspectionRecordList}
                        formLabel=""
                        error={errors.otherIT}
                        defaultValue={null}
                        disabled={isEdit || serviceOrderInputId || isReadOnly}
                        onClear={() => clearEquipmentFields()}
                        margin={"0"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <FormAutocomplete
                        name="serviceOrder"
                        control={controlForm}
                        label="Orden de Servicio"
                        options={serviceOrderList}
                        formLabel=""
                        error={errors.serviceOrder}
                        defaultValue={null}
                        disabled={isEdit || ispectionRecordId || isReadOnly}
                        onClear={() => clearEquipmentFields()}
                        margin={"0"}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12} sm={6} md={4}>
                  <p className="select-form-label">Fecha de Creación de Orden</p>
                  <FormCalendar
                    name="creationOrderDate"
                    control={controlForm}
                    width={"100%"}
                    formLabel=""
                    error={errors.creationOrderDate}
                    defaultValue={null}
                    disabled={isEdit || isReadOnly}
                    // minDate={minDate}
                    maxDate={maxDate}
                    disableWeekends={true}
                    disabledDates={disabledDates}
                    margin={"0"}
                  />
                </Grid>

                {/* Tercera fila */}
                <Grid item xs={12} sm={6} md={4} className="biomedical-service-order-series">
                  <MultiSelect
                    name="serie"
                    control={controlForm}
                    proplabel="Serie"
                    options={
                      institutionWatch?.value
                        ? serieList.filter(
                            (option) =>
                              Number(option.institutionId) ===
                                Number(institutionWatch.value) ||
                              normalizedWatchSerieIds.some(
                                (serieId) =>
                                  String(serieId) === String(option.value)
                              )
                          )
                        : serieList
                    }
                    margin={"0"}
                    error={errors.serie}
                    disabled={isEdit || isReadOnly}
                    isMultiple={isMultiSerie}
                    searchBar={true}
                  />
                </Grid>

      

                <Grid item xs={12} sm={12} md={12}>
                  <ShowTable
                    loading={loadingEquipment}
                    data={seriesDataTable}
                    columns={columns}
                    rows={5}
                    showTooltips={true}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  {!isCompleted && (
                    <FormSelect
                      name="state"
                      control={controlForm}
                      formLabel="Seleccionar estado"
                      label="Estado"
                      options={generateSelectList(
                        stateListFiltered,
                        "order_state_id",
                        "stateName"
                      )}
                      error={errors.state}
                      disabled={isCompleted || isReadOnly}
                    />
                  )}
                  {isCompleted && (
                    <FormTextField
                      name={"statetoChecK"}
                      control={controlForm}
                      label="Estado"
                      disabled={true}
                      margin={"0"}
                      labelColor={"#333333"}
                      defaultValue={"Entrega y cierre de OS"}
                    />
                  )}
                </Grid>

                {stateWatch === statesServiceOrderEnum.EngineerinReport && (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <LaddaButton
                      fontSize={"12px"}
                      height={"40px"}
                      variant="contained"
                      type="button"
                      onClick={handleEngineeringReport}
                    >
                      <p className="button_text">Reporte de Ingeniería</p>
                    </LaddaButton>
                  </Grid>
                )}

                {stateWatch === statesServiceOrderEnum.Testing && (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <Grid item xs={12}>
                      <p className="create-label ml-0">Anexo*</p>
                      <FileUploadButton
                        onFileChange={handleFileChange}
                        path={fileUrl}
                        buttonText="Subir archivo (PDF o imagen)"
                        disabled={fileUrl !== null}
                      />
                    </Grid>
                  </Grid>
                )}

                {stateWatch === statesServiceOrderEnum.Return && (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <Grid item xs={12}>
                      <p className="create-label ml-0">Anexo*</p>
                      <FileUploadButton
                        onFileChange={handleFileChange}
                        path={fileUrl}
                        buttonText="Subir archivo (PDF o imagen)"
                        disabled={fileUrl !== null}
                      />
                    </Grid>
                  </Grid>
                )}

                {commentShow &&
                  !!stateWatch &&
                  requiresComment(stateWatch) &&
                  stateWatch !== statesServiceOrderEnum.EngineerinReport &&
                  stateWatch !== statesServiceOrderEnum.Testing &&
                  stateWatch !== statesServiceOrderEnum.Return && (
                    <Grid item xs={12} sm={12} md={12}>
                      <div>
                        <FormTextField
                          name={"comment"}
                          control={controlForm}
                          label="Comentario"
                          isTextArea={true}
                          error={errors.comment}
                          maxLength={500}
                          rows={3}
                          disabled={isCompleted || isReadOnly}
                          margin={"0"}
                          labelColor={"#333333"}
                        />
                        <CharacterCounter
                          name={"comment"}
                          control={controlForm}
                          maxLength={500}
                        />
                      </div>
                    </Grid>
                  )}
              </Grid>

              {isReadOnly
                ? null
                : !isCompleted && (
                    <div className="j-center white-space">
                      <LaddaButton
                        width={"160px"}
                        fontSize={"12px"}
                        height={"40px"}
                        variant="contained"
                        type="submit"
                        disabled={submitting}
                        loading={submitting}
                      >
                        <p className="button_text">
                          {submitting
                            ? "Procesando..."
                            : stateWatch ===
                              statesServiceOrderEnum.DeliveryOSClosure
                            ? "Finalizar"
                            : "Guardar"}
                        </p>
                      </LaddaButton>
                    </div>
                  )}
              </fieldset>
            </form>
            </LoadingFeedback>

            <HistoryModalUnique
              open={openHistory}
              close={handleCloseHistory}
              id={serviceOrderId}
              module="serviceOrder"
            />
          </div>
        </div>
      </div>

      <ToastNotification
        severity={toastConfig.severity}
        summary={toastConfig.summary}
        detail={toastConfig.detail}
        showToast={showToast}
        setShowToast={setShowToast}
        position="top-right"
      />

      <CreateVerificationModal
        open={openRequestValidation}
        onConfirm={handleConfirmYes}
        onCancel={handleConfirmNo}
        // Si tu modal aún usa `close`, puedes pasar lo mismo:
        close={handleConfirmNo}
      />
    </div>
  );
};

export default CreateRequest;
